module.exports = __webpack_public_path__ + "img/znch2.810c528.png";